export class Project {
    foremanId = null;
    requestedById = null;
    projectManagerId = null;
    projectName = '';
    subcontractorId = null;
    workOrderNumber = '';
    dispatchCompanyId = '';
    meetingLocation = null;
    jobLocation = null;
    notes = '';
    jobs = [];
    resources = [];
    jobTypeId = null;
}